import csfApiWrapper from 'services/api/creatorStoreFront/csfApiWrapper';

/**
 * Fetch siteID from the creator-storefront LinkSynergy/Rakuten adapter.
 *
 * @param {string} linkshareSiteId Publisher ID from creator profile.
 * @param {string|number} mid Merchant ID from creator profile.
 * @param {string} murl Current page URL passed through to Rakuten.
 * @param {string} u1 CSF attribution `u1` parameter.
 * @param {string} [u5] Optional creator tier from the Profile API. Included in
 *     the payload only when it is a non-empty string (graceful fallback when
 *     the Profile API does not return `u5`).
 * @returns {Promise<{ data: object, headers: object }>}
 */
async function getSiteIdFromLinkSynergy(linkshareSiteId, mid, murl, u1, u5) {
    const url = '/gway/v1/creator-storefront/rakuten/site-id';
    const payload = {
        linkshareSiteId,
        mid,
        murl,
        u1
    };

    if (typeof u5 === 'string') {
        const trimmedU5 = u5.trim();

        if (trimmedU5.length > 0) {
            payload.u5 = trimmedU5;
        }
    }

    // Thin transport: just throw on failure. Both wrappers
    // (`fetchDcSiteIdFromLinkSynergy` in DC, `fetchSiteIdFromLinkSynergy`
    // in legacy CSF attribution) own logging with namespace-specific
    // context; logging here would only produce duplicate `error` entries.
    const data = await csfApiWrapper.makeAuthenticatedPostRequest(url, payload);

    if (data?.fault || data?.responseStatus !== 200) {
        const fault =
            data?.fault ||
            new Error(`getSiteIdFromLinkSynergy failed with responseStatus=${data?.responseStatus}`);

        throw fault;
    }

    return {
        data: { ...data },
        headers: {}
    };
}

export default getSiteIdFromLinkSynergy;
